import api from '@/services/api'

export async function sendTestReply(
  blobAudio: Blob,
  retryCount: number = 0
): Promise<unknown> {
  const formData = new FormData()

  // Extract file extension from blob type
  const mimeType = blobAudio.type.split(';')[0]
  const extension = mimeType?.split('/').pop() || 'webm'

  const audio = new File([blobAudio], `audio.${extension}`, {
    type: blobAudio.type
  })

  formData.append('audio', audio)

  try {
    const { data } = await api.post('/fluency-test/reply', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return data
  } catch (error) {
    // Retry up to 3 times
    if (retryCount < 2) {
      return sendTestReply(blobAudio, retryCount + 1)
    }
    throw error
  }
}
